import { createEl } from "./utils.js";

function createSnackbar() {
    const [el] = createEl()
    const root = el("div", { class: "snackbar-container" });

    function dispatch(text, context, duration = 5000) {
        const bar = el("div", { class: `snackbar ${context}` }, text);
        root.append(bar);
        if(duration !== 0) {
            setTimeout(() => {
                bar.remove();
            }, duration);
        }
        return bar;
    }

    return {
        root,
        dispatch,
    };
}

export default createSnackbar();
